import script from "./VODCaptionsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VODCaptionsTab.vue?vue&type=script&setup=true&lang=js"

import "./VODCaptionsTab.vue?vue&type=style&index=0&id=2f645a7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f645a7b"]])

export default __exports__